var __jsx = React.createElement;
import React from 'react';
import { useTranslation } from "@i18n";
import { useCarCompareContext } from "@/_MiniApps/CarCompare/CarCompare";
import useIsMobile from "@hooks/useIsMobile";
import { CDN_LINK } from "@globalConfig";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
import { AuthPopupHOC, useSession } from "@/_MiniApps/auth/AuthContext";
import { useCMS } from "@hooks/useCMS";
import banners from "@data/banners/login-pages/car_report.json";
import { handleHasAccountEvent } from "@/utils/common";
import { trackEvents } from "@/common/events/events";
import { twMerge } from "tailwind-merge";
var StartCompareBar = function StartCompareBar(_ref) {
  var _bigData$cars;
  var _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? "" : _ref$containerClassNa;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var _useCarCompareContext = useCarCompareContext(),
    bigData = _useCarCompareContext.bigData,
    removeCar = _useCarCompareContext.removeCar,
    canStartComparison = _useCarCompareContext.canStartComparison,
    isCompareBarAllowed = _useCarCompareContext.isCompareBarAllowed,
    getLocationNameFromPathName = _useCarCompareContext.getLocationNameFromPathName,
    hasCarsToCompare = _useCarCompareContext.hasCarsToCompare;
  var isMobile = useIsMobile();
  var lang = useLang();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateTo = _useHelpers.navigateTo;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var authScreenDesign = {
    banners: {
      desktop: imageUrl(banners[lang].desktop_images[0]),
      mobile: imageUrl(banners[lang].mobile_images[0])
    },
    title: t("ابدأ مقارنة السيارات الآن!", {
      ns: "web_common"
    }),
    description: t("سجل الدخول أو قم بإنشاء حساب الآن لتتمكن من الإطلاع على جدول المقارنة.", {
      ns: "web_common"
    })
  };
  var triggerStartComparisonEvent = function triggerStartComparisonEvent(checkAuth) {
    checkAuth(function (userData, isPendingActionCall) {
      isPendingActionCall && handleHasAccountEvent({
        hasAccount: userData.has_account,
        status: "Success",
        phone_number: userData === null || userData === void 0 ? void 0 : userData.phone_number,
        lang: "ar",
        referral_location: "inspection_report"
      });
      isPendingActionCall && trackEvents("element_click", {
        element_name: "comparison",
        user_login_status: "true"
      });
      trackEvents("comparison_start", {
        user_id: isLoggedIn ? "9665" + user.phone_number : "null",
        referral_location: getLocationNameFromPathName(location.pathname),
        post_1_id: bigData.cars[0].id,
        post_1_make: bigData.cars[0].g4_data_layer.post_make,
        post_1_model: bigData.cars[0].g4_data_layer.post_model,
        post_1_year: bigData.cars[0].g4_data_layer.post_year,
        post_1_condition: bigData.cars[0].g4_data_layer.post_condition,
        post_2_id: bigData.cars[1].id,
        post_2_make: bigData.cars[1].g4_data_layer.post_make,
        post_2_model: bigData.cars[1].g4_data_layer.post_model,
        post_2_year: bigData.cars[1].g4_data_layer.post_year,
        post_2_condition: bigData.cars[1].g4_data_layer.post_condition
      });
      var queryParams = "compare_cars=".concat(bigData.cars.map(function (car) {
        return car.id;
      }).join(","));
      navigateTo(createUrl("/site/car-compare?".concat(queryParams)));
    });
  };
  if (!isCompareBarAllowed() || !canStartComparison() || !hasCarsToCompare()) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: ["flex items-center justify-start p-3 gap-6 fixed z-[99999] w-[90%] md:w-[500px] h-[64px] flex-shrink-0 rounded-[4px] bg-[#3C56D4] shadow-[0px_8px_12px_0px_rgba(0,0,0,0.15)] bottom-[32px] right-[5%] md:ar:right-[calc(145px+50%-250px)] md:en:left-[calc(145px+50%-250px)]", twMerge(containerClassName)].join(" ")
  }, bigData === null || bigData === void 0 ? void 0 : (_bigData$cars = bigData.cars) === null || _bigData$cars === void 0 ? void 0 : _bigData$cars.map(function (car, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index + "StartCompareBar"
    }, index > 0 && /*#__PURE__*/React.createElement("span", {
      className: "w-[1px] h-[32px] bg-[#E1E8F2]"
    }), /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        removeCar(parseInt(car.id, 10));
      },
      className: "cursor-pointer border-solid w-[64px] h-[40px] rounded-[1.6px] border-[0.4px] border-[#E1E8F2] relative"
    }, /*#__PURE__*/React.createElement("img", {
      onClick: function onClick() {
        removeCar(parseInt(car.id, 10));
      },
      className: "hasEvents absolute ar:left-[-8px] en:right-[-8px] top-[-8px] z-[2]",
      width: "16px",
      height: "16px",
      src: CDN_LINK + "/assets/images/closeCompare.svg",
      alt: "remove car"
    }), /*#__PURE__*/React.createElement("img", {
      className: "object-cover w-full h-full absolute left-0 top-0 z-[1]",
      src: (car === null || car === void 0 ? void 0 : car.image_url) || (car === null || car === void 0 ? void 0 : car.img_url),
      alt: car === null || car === void 0 ? void 0 : car.title
    })));
  }), /*#__PURE__*/React.createElement(AuthPopupHOC, {
    customModalClassName: "modalHideHeader",
    authScreenDesign: authScreenDesign,
    onCancel: function onCancel() {
      trackEvents("element_click", {
        element_name: "comparison",
        user_login_status: "false"
      });
    },
    renderFunc: function renderFunc(checkAuth) {
      return /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          triggerStartComparisonEvent(checkAuth);
        },
        className: "cursor-pointer border-none bg-transparent flex items-center ar:mr-auto en:ml-auto w-1/2 justify-end"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-white text-sm font-bold leading-[16px] md:text-base md:leading-[24px]"
      }, t("قارن", {
        ns: "web_sell_trade"
      })), /*#__PURE__*/React.createElement("img", {
        className: "ar:rotate-180",
        width: "24",
        height: "24",
        src: CDN_LINK + "/assets/images/whtBck.svg",
        alt: "arrow"
      }));
    }
  }));
};
export default StartCompareBar;